export default __webpack_public_path__ + "static/media/Nexus_6_piccolo_display_trasparent.d3399cb7.png";